import { useState } from "react";
import { Cookie } from "lucide-react";
import { CONSENT_KEY } from "../lib/analytics";

export default function ConsentNotice() {
    const [open, setOpen] = useState(() => !localStorage.getItem(CONSENT_KEY));
    if (!open) return null;

    const dismiss = (choice) => {
        localStorage.setItem(CONSENT_KEY, choice);
        setOpen(false);
    };

    return (
        <div
            data-testid="cookie-notice"
            className="fixed bottom-4 left-4 z-[70] max-w-[320px] rounded-2xl border border-amber-200/20 bg-[#1b140c]/95 p-4 shadow-2xl backdrop-blur-md"
        >
            <div className="flex items-start gap-3">
                <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-amber-300" />
                <div>
                    <p className="text-sm leading-relaxed text-amber-100/80">
                        We use a few cookies to understand how our site is used, so we can keep
                        improving your experience. Your visit helps us grow.
                    </p>
                    <div className="mt-3 flex items-center gap-2">
                        <button
                            data-testid="cookie-accept"
                            onClick={() => dismiss("accepted")}
                            className="rounded-full bg-amber-400 px-4 py-1.5 text-xs font-semibold text-[#1b140c] hover:bg-amber-300"
                        >
                            Okay
                        </button>
                        <button
                            data-testid="cookie-dismiss"
                            onClick={() => dismiss("dismissed")}
                            className="rounded-full px-3 py-1.5 text-xs text-amber-100/50 hover:text-amber-100/80"
                        >
                            Dismiss
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
